/* eslint-disable */
import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { Box } from '@mui/material';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
// import Paper from '@mui/material/Paper';
// import { Tooltip, IconButton } from '@mui/material';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
// import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
// import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import RouteConstants from '../../constants/routeConstants';
import SelectModule from './selectModule';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import Helper from '../../utility/helper';
import {
// useModuleDrawerState,
setDrawerOpen,
} from '../../hookState/ModuleDrawerState';
import { useEventState, updateModuleDetailsList } from '../../stores/eventStore';
import DataList from '../../sharedcomponents/dataList/dataList';
import { FULL_PERMISSION, VIEW_PERMISSION, NO_ACCESS_PERMISSION } from '../../constants/Constant';
import EditModule from './editModule';
import AutoApproveModule from './autoApprove';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';

const Module = () => {
    const openModel = useState(false);
    const moduleList = useState([]);
    const eventModuleList = useState([]);
    const loading = useState(true);
    const openUserDialog = useState(false);
    const openApproveDialog = useState(false);
    const moduleInfo = useState(null);
    const eventState = useEventState();
    // const moduleDrawerState = useModuleDrawerState();
    const eventInfo = Helper.getStorage('eventInfo');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    const [moduleData, setModuleData] = React.useState(null)
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');

    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');

    const editUser = (userInfo) => {
        moduleInfo.set(userInfo.actualData);
        openUserDialog.set(true);
    };
    const onModuleSettingClick = (userInfo) => {
        moduleInfo.set(userInfo.actualData);
        openApproveDialog.set(true);

    }

    const handleCloseModule = () => {
        openUserDialog.set(false);
        openApproveDialog.set(false);
    };

    const handleClick = () => {
        openModel.set(true);
    };

    const handleClose = () => {
        openModel.set(false);
    };

    const handleAction = () => {
        getModuleList();
    };

    async function getModuleList() {
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');

        const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');

        if (userInfo.roles && !(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) && Helper.isEventStaff(userInfo)) {
            // console.log("into staff");
            ApiHelper.get(APIURLConstants.GET_EVENT_STAFF_MODULES(eventInfo.eventID, userInfo.userID))
                .then((res) => {
                    const newData = res.data.eventModules;
                    let data = [];
                    let moduleData = [];
                    if (newData && newData.length > 0) {
                        const userInfo = Helper.getStorage('userInfo');
                        const permissions = (userInfo.roles && Helper.isEventAdmin(userInfo))
                            ? eventState.permissions.attach(Downgraded).get()
                            : [];
                        //if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo)) {
                        if (permissions && permissions.length > 0) {
                            newData.map((item, index) => {
                                let fIndex = permissions.findIndex(perm => item.moduleName.toUpperCase().indexOf(perm.module) > -1);
                                if (fIndex > -1 && permissions[fIndex].permission != NO_ACCESS_PERMISSION) {
                                    data.push(item);
                                }
                            })
                        }
                        else {
                            newData.map((item) => data.push(item));
                        }
                    }

                    if (data && data.length > 0) {
                        data.map((item) => {
                            // if (item.moduleName !== "MediaCircuit")
                            // {
                            moduleData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'Module',
                                        key: 'moduleName',
                                        moduleName: item.moduleName,
                                        width: '0.4',
                                        showLabel: false,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status: item.status ? 'Active' : 'Inactive',
                                        width: '0.2',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Created Date',
                                        key: 'createdDate',
                                        createdDate: Helper.FormatMonthWithDate(
                                            item.createdDate
                                        ),
                                        width: '0.2',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.2',
                                    },
                                ],
                            });
                            // }
                        });

                        let moduleDetails = moduleData.map(x => {
                            let obj = {};
                            obj['moduleID'] = x.actualData.moduleID;
                            obj['moduleName'] = x.actualData.moduleName;
                            obj['displayName'] = x.actualData.displayName;
                            obj['eventID'] = x.actualData.eventID;
                            obj['details'] = x.actualData.details;
                            obj['showAgentProDayParticipant'] = x.actualData.showAgentProDayParticipant;
                            obj['agentProDayParticipantText'] = x.actualData.agentProDayParticipantText;
                            return obj;

                        })
                        updateModuleDetailsList(moduleDetails);

                    }

                    moduleList.set(moduleData);
                    eventModuleList.set(data);
                    setDrawerOpen(data);
                    loading.set(false);
                }).catch((error) => {
                    loading.set(false);
                    if (error.response && error.response.status === 401) {
                        alert(error);
                    }
                });
        } else {
            ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false, true))
                .then((res) => {
                    const newData = res.data;
                    let data = [];
                    let moduleData = [];
                    if (newData && newData.length > 0) {
                        const userInfo = Helper.getStorage('userInfo');
                        // console.log("userInfo.roles : ", userInfo.roles);
                        // console.log("isAdminUser.roles : ", Helper.isAdminUser(userInfo));
                        // console.log("isEventAdmin : ", Helper.isEventAdmin(userInfo))
                        // const permissions = (userInfo.roles && (Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)))
                        //     ? eventState.permissions.attach(Downgraded).get()
                        //     : [];
                        // //if (!Helper.isAdminUser(userInfo) && !Helper.isEventAdmin(userInfo)) {
                        // if (permissions && permissions.length > 0)
                        // {
                        //     newData.map((item, index) =>
                        //     {
                        //         let fIndex = permissions.findIndex(perm => item.moduleName.toUpperCase().indexOf(perm.module) > -1);
                        //         if (fIndex > -1 && permissions[fIndex].permission != NO_ACCESS_PERMISSION)
                        //         {
                        //             data.push(item);
                        //         }
                        //     })
                        // }
                        // else
                        // {
                        newData.map((item) => data.push(item));
                        // }
                    }
                    // console.log("data", data);
                    if (data && data.length > 0) {
                        data.map((item) => {
                            // if (item.moduleName !== "MediaCircuit")
                            // {
                            moduleData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'Module',
                                        key: 'moduleName',
                                        moduleName: item.moduleName == "DraftHotel" ? "Player Hotel" : item.moduleName,
                                        width: '0.25',
                                        showLabel: false,
                                    },
                                    {
                                        label: 'Module',
                                        key: 'displayName',
                                        displayName: item.displayName,
                                        width: '0.25',
                                        showLabel: false,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'status',
                                        status: item.status ? 'Active' : 'Inactive',
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Created Date',
                                        key: 'createdDate',
                                        createdDate: Helper.FormatMonthWithDate(
                                            item.createdDate
                                        ),
                                        width: '0.2',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.2',
                                    },
                                ],
                            });
                            // }
                        });

                        let moduleDetails = moduleData.map(x => {
                            let obj = {};
                            obj['moduleID'] = x.actualData.moduleID;
                            obj['moduleName'] = x.actualData.moduleName;
                            obj['displayName'] = x.actualData.displayName;
                            obj['fromInvitationEmail'] = x.actualData.fromInvitationEmail;
                            obj['eventID'] = x.actualData.eventID;
                            obj['details'] = x.actualData.details;
                            obj['showAgentProDayParticipant'] = x.actualData.showAgentProDayParticipant;
                            obj['agentProDayParticipantText'] = x.actualData.agentProDayParticipantText;
                            return obj;

                        })
                        updateModuleDetailsList(moduleDetails);

                    }
                    // console.log('moduleData : ', moduleData);
                    moduleList.set(moduleData);
                    eventModuleList.set(data);
                    setDrawerOpen(data);
                    loading.set(false);
                }).catch((error) => {
                    loading.set(false);
                    if (error.response && error.response.status === 401) {
                        alert(error);
                    }
                });
        }



    };
    useEffect(() => {
        if (eventState && eventState.eventDetail.get() != null && modPermission == null) {
            // const userInfo = Helper.getStorage('userInfo');
            if (Helper.isAdminUser(userInfo) || (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))) {
                setModPermission(FULL_PERMISSION);
                getModuleList();
            }
            else {
                setModPermission(NO_ACCESS_PERMISSION);
            }
        }
    }, [eventState]);
    // const redirectUrl = (moduleName) => {
    //     if (moduleName === 'Transportation') {
    //         props.history.push(RouteConstants.EVENT_TRANSIT);
    //     }
    // };
    const reorder = (startIndex, endIndex) => {
        const newModuleList = [...moduleList.attach(Downgraded).get()];
        const [removed] = newModuleList.splice(startIndex, 1);
        newModuleList.splice(endIndex, 0, removed);
        let data = [];
        let moduleData = [];
        newModuleList.forEach((item, index) => {
            const row = item.actualData;
            moduleData.push(row);
            data.push({
                eventModuleID: row.eventModuleID,
                order: index + 1,
            });
        });

        moduleList.set(newModuleList);
        setDrawerOpen(moduleData);
        updateModuleOrder(data);
    };
    const updateModuleOrder = (data) => {
        ApiHelper.post(APIURLConstants.UPDATE_EVENT_MODULE_ORDERS, data)
            .then((res) => {
                if (res.data) {
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const onDragEnd = ({ destination, source }) => {
        if (!destination) return;
        reorder(source.index, destination.index);
    };
    const handleModuleDelete = (data) => {
        let message = 'Do you want to delete?'
        deleteConfirmation.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
        setModuleData(data)
    }
    const onDelete = (data) => {
        const obj = {
            EventID: moduleData.actualData.eventID,
            ModuleID: moduleData.actualData.moduleID
        }
        ApiHelper.post(APIURLConstants.DELETE_EVENT_MODULE, obj)
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({ openSnack: true, variant: 'success', message: 'Module deleted successfully.' });
                    if (moduleData.actualData.moduleID === 15) {
                        location.reload();
                    }
                    getModuleList();
                } else {
                    setSnackBarProps({ openSnack: true, variant: 'error', message: 'Something went wrong.' });
                }
                setModuleData(null);
                deleteConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });

    }
    return (
        <>
            <Box className="otherContentBox" sx={{
                overflow: 'auto',
                maxHeight: 'calc(100vh - 70px)',
            }}>
                {loading.get() === true ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                        }}>
                        <CircularProgress />
                    </Box>
                ) :
                    <>
                        {
                            modPermission && modPermission == NO_ACCESS_PERMISSION ?
                                <UnauthorizedUI showLogout={false} />
                                :
                                (
                                    <DataList
                                        data={moduleList.attach(Downgraded).get()}
                                        editRow={editUser}
                                        handleClick={handleClick}
                                        title={'List Of Modules'}
                                        buttonTitle={'Add'}
                                        showSearch={false}
                                        handleDelete={handleModuleDelete}
                                        hideAdd={(userInfo.roles && !(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) && Helper.isEventStaff(userInfo)) ? true : false}
                                        showDelete={!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)) && Helper.isEventStaff(userInfo) ? false : true}
                                        hideDelete={(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo)) ? true : false}
                                        isDraggable={true}
                                        onDragEnd={onDragEnd}
                                        modPermission={modPermission}
                                        showModuleSetting={true}
                                        onModuleSettingClick={onModuleSettingClick}
                                    />
                                )
                        }
                    </>
                }
                {openUserDialog.get() && (
                    <EditModule
                        open={openUserDialog.get()}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        title="Edit Module Information"
                        handleCloseModule={handleCloseModule}
                        handleAction={handleAction}
                        moduleInfo={moduleInfo.attach(Downgraded).get()}
                        moduleList={moduleList.attach(Downgraded).get()}
                    />
                )}
                {openModel.get() && (
                    <SelectModule
                        open={openModel.get()}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        title="Add Modules"
                        handleClose={handleClose}
                        handleAction={handleAction}
                        moduleEventList={eventModuleList}
                    />
                )}
                {
                    <ConfirmationDialog
                        open={deleteConfirmation.get().open}
                        message={deleteConfirmation.get().message}
                        OkButtonText={deleteConfirmation.get().OkButtonText}
                        handleCnfClick={() =>
                            onDelete(deleteConfirmation)
                        }
                        onCancelClick={() => {
                            deleteConfirmation.set({
                                ...deleteConfirmation.get(),
                                open: false,
                            });
                        }}></ConfirmationDialog>
                }
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
                {openApproveDialog.get() && (
                    <AutoApproveModule
                        open={openApproveDialog.get()}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        title="Settings Module"
                        handleCloseModule={handleCloseModule}
                        handleAction={handleAction}
                        moduleInfo={moduleInfo.attach(Downgraded).get()}
                    />
                )}
            </Box>
        </>
    );
};

export default {
    routeProps: {
        path: RouteConstants.MODULE,
        component: Module,
    },
    name: 'Module',
};
